/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';
import {MdDatepicker} from './datepicker';
import {MdDatepickerIntl} from './datepicker-intl';
export class MdDatepickerToggle<D> {
/**
 * Datepicker instance that the button will toggle.
 */
datepicker: MdDatepicker<D>;
/**
 * @return {?}
 */
get _datepicker() { return this.datepicker; }
/**
 * @param {?} v
 * @return {?}
 */
set _datepicker(v: MdDatepicker<D>) { this.datepicker = v; }
/**
 * @param {?} _intl
 */
constructor(public _intl: MdDatepickerIntl) {}
/**
 * @param {?} event
 * @return {?}
 */
_open(event: Event): void {
    if (this.datepicker) {
      this.datepicker.open();
      event.stopPropagation();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'button[mdDatepickerToggle], button[matDatepickerToggle]',
  template: '',
  styleUrls: ['datepicker-toggle.css'],
  host: {
    'type': 'button',
    'class': 'mat-datepicker-toggle',
    '[attr.aria-label]': '_intl.openCalendarLabel',
    '(click)': '_open($event)',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDatepickerIntl, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'datepicker': [{ type: Input, args: ['mdDatepickerToggle', ] },],
'_datepicker': [{ type: Input, args: ['matDatepickerToggle', ] },],
};
}

function MdDatepickerToggle_tsickle_Closure_declarations() {
/** @type {?} */
MdDatepickerToggle.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDatepickerToggle.ctorParameters;
/** @type {?} */
MdDatepickerToggle.propDecorators;
/**
 * Datepicker instance that the button will toggle.
 * @type {?}
 */
MdDatepickerToggle.prototype.datepicker;
/** @type {?} */
MdDatepickerToggle.prototype._intl;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
